import React from 'react';
import { FaList } from 'react-icons/fa';
import { StyledBox } from '../components/shared/StyledBox';

export type OrderMode = 'normal' | 'inverse' | 'estado' | 'capital';

type Props = {
  value: OrderMode;
  onChange: (next: OrderMode) => void;
};

const nextModeMap: Record<OrderMode, OrderMode> = {
  normal: 'inverse',
  inverse: 'estado',
  estado: 'capital',
  capital: 'normal',
};

const labelMap: Record<OrderMode, string> = {
  normal: 'Fecha ↓',
  inverse: 'Fecha ↑',
  estado: 'Estado',
  capital: 'Capital',
};

export const OrderToggleButton: React.FC<Props> = ({ value, onChange }) => {
  return (
    <StyledBox
      mt={['16px', '0px']}
      gap={'8px'}
      whiteSpace="noWrap"
      alignItems={'center'}
      alignSelf={'end'}
      fontSize={'12px'}
      color="white"
      width={'fit-content'}
      padding={'8px'}
      fontWeight={500}
      borderRadius="4px"
      backgroundColor={'secondary.1'}
      onClick={() => onChange(nextModeMap[value])}
    >
      <FaList />
      {labelMap[value]}
    </StyledBox>
  );
};
